import { render } from "./defaultTemplate.vue?vue&type=template&id=4dd1def3"
const script = {}
script.render = render

export default script